import { InputText } from "primereact/inputtext";
import DevicesViewSwitcher from "./DevicesViewSwitcher";
import {
  PageHeader,
  SearchBarContainer,
  SearchInputContainer,
} from "styles/devices/devicesList.styles";

type ViewType = "cards" | "map" | "table";

interface DevicesListToolbarProps {
  searchInputValue: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  viewType: ViewType;
  onViewChange: (view: ViewType) => void;
  onAddDeviceClick?: () => void;
  onRequestTemporaryAccessClick?: () => void;
  temporaryRequestLimitReached?: boolean;
}

export function DevicesListToolbar({
  searchInputValue,
  onSearchChange,
  viewType,
  onViewChange,
  onAddDeviceClick,
  onRequestTemporaryAccessClick,
  temporaryRequestLimitReached = false,
}: DevicesListToolbarProps) {
  return (
    <PageHeader>
      <SearchBarContainer>
        <SearchInputContainer>
          <span className="p-input-icon-left">
            <i className="pi pi-search" style={{ marginLeft: 10 }} />
            <InputText
              name="device-search"
              autoComplete="off"
              value={searchInputValue}
              onChange={onSearchChange}
              placeholder="Search devices..."
            />
          </span>
        </SearchInputContainer>
      </SearchBarContainer>
      <DevicesViewSwitcher
        currentView={viewType}
        onViewChange={onViewChange}
        onAddDeviceClick={onAddDeviceClick}
        onRequestTemporaryAccessClick={onRequestTemporaryAccessClick}
        temporaryRequestLimitReached={temporaryRequestLimitReached}
      />
    </PageHeader>
  );
}
